var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiconAp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8569 16C26.8569 10.0038 21.996 5.14285 15.9997 5.14285C10.0035 5.14285 5.14258 10.0038 5.14258 16C5.14258 21.9962 10.0035 26.8571 15.9997 26.8571C21.996 26.8571 26.8569 21.9962 26.8569 16Z",
    stroke: "#A1A1A1",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5706 16C22.5706 12.3707 19.6285 9.42856 15.9992 9.42856C12.3699 9.42856 9.42773 12.3707 9.42773 16C9.42773 19.6293 12.3699 22.5714 15.9992 22.5714C19.6285 22.5714 22.5706 19.6293 22.5706 16Z",
    stroke: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1431 15.4286H14.8574V16.5714H17.1431V15.4286Z",
    fill: "#73B8FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiconAp);
export default __webpack_public_path__ + "static/media/dicon_ap.dd6c1125da3163453c57293a6d02d0b3.svg";
export { ForwardRef as ReactComponent };